import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import FormAaa from "./modules/client/form_aaa";
import SupportForm from "./modules/admin/Support";
import AfterHoursForm from "./modules/client/AAACallCenter";
import FormAdams from "./modules/client/form_adams";
import FormAaron from "./modules/client/form_aaron";
import FormAaronOrganic from "./modules/client/form_aaron_organic";
import FormRoyal from "./modules/client/form_Royal";
import FormFAI from "modules/client/form_FAI";
import FormWillowCV from "modules/client/form_willow_cv";
import ClientLandingPage from "./modules/client/client_landing_page";
import NewHome from "./modules/new-page-home/new_home";
import PlansPage from "./modules/new-page-home/PlansPage/plansPage";
import { AuthProvider } from "context/AuthContext";
import { BusinessProvider } from "context/BusinessContext";
import Wesipsafe from "modules/wesipsafe/Wesipsafehome";
import WesipsafeLogin from "modules/wesipsafe/WesipsafeLogin";
import FormWidgetChat from "modules/client/form_widget_Chat";


import PricingPage from "modules/client/PricingPage";
import ServicesPlans from "modules/client/ServicesPlans";
import SignWithInvoice from "auth/SignWithInvoice/SignWithInvoice";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutPage from "services/payments/CheckoutPage";
import UpgradeCheckout from "services/payments/UpgradeCheckoutPage";
import LocationFinder from "modules/client/test_location";
import FormAzucarai from "modules/client/form_azucarai";
import AuthCallback from "auth/login/auth_callback";
import PlanExpiredNotice from "auth/expired";
import ChatWidget from "components/ChatWidget";
import WidgetPage from "modules/client/chatWidget/WidgetPage";
import { useLocation } from "react-router-dom";
import PrivacyPolicy from "pages/PrivacyPolicy";
import TermsOfService from "pages/TermsOfService";
import UserDataDeletion from "pages/UserDataDeletion";
import SupportApp from "pages/SupportApp";
import Copyright from "pages/Copyright";
import ImageDatabase from "modules/client/ImageDatabase";
import ImageDatabaseView from "modules/client/ImageDatabaseView";


// <Route
// path="/form_aaa"
// element={
//   <FormAaa
//     idTrackGoogleAds={"AW-11536860637"}
//     id2={"AOZmCJ_DhY0aEN2Lmv0q"}
//   />
// }
// />
// <Route path="/aaacallcenter" element={<AfterHoursForm />} />

const stripePromise = loadStripe(
  "pk_test_51QGQTkCtf3ESElJ3xz7bgjmmmFde6W8qUOw4F1UuMT1vgfK5QR9jzNgsSERRDEWHMVZ936yhDBWwsypUtAa6zh5K00TCbWa5bm"
);

const AppContent = () => {
  const location = useLocation();
  const isFormPage = location.pathname.startsWith('/form_');

  // Definir las rutas donde NO debe aparecer el widget
  const isAppPage = location.pathname.startsWith('/dashboard_') ||
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/signup') ||
    location.pathname.startsWith('/reset-password') ||
    location.pathname.startsWith('/auth/') ||
    location.pathname.startsWith('/support') ||
    location.pathname.startsWith('/plan_expired') ||
    location.pathname.startsWith('/unauthorized') ||
    location.pathname.startsWith('/widget') ||
    location.pathname.startsWith('/image_data_base') ||
    location.pathname.startsWith('/');

  // Solo mostrar el widget en páginas del sitio web público (no en app, auth o forms)
  const shouldShowWidget = !isFormPage && !isAppPage;

  return (
    <>
      {shouldShowWidget && <ChatWidget />}
      <Routes>
        <Route path="/plan_expired" element={<PlanExpiredNotice />} />

        {/* Landing Pages */}
        <Route path="/" element={<ClientLandingPage />} />
        <Route path="/new-home" element={<NewHome />} />
        <Route path="/plans-page" element={<PlansPage />} />

        <Route path="/plans" element={<PricingPage />} />
        <Route path="/services-plans" element={<ServicesPlans />} />
        <Route path="/wesipsafe" element={<Wesipsafe />} />
        <Route path="/wesipsafe_login" element={<WesipsafeLogin />} />
        <Route path="/test_location" element={<LocationFinder />} />

        <Route path="/checkout/:planId" element={<CheckoutPage />} />
        <Route path="/SignWithInvoice" element={<SignWithInvoice />} />
        <Route
          path="/upgrade-checkout/:planId"
          element={<UpgradeCheckout />}
        />

        {/* Forms publics */}

        <Route path="/form_adams" element={<FormAdams />} />
        {/* <Route path="/form_aaron" element={<FormAaron />} /> */}
        <Route path="/form_willow_cv" element={<FormWillowCV />} />
        {/* <Route
          path="/form_aaron_organic"
          element={<FormAaronOrganic />}
        /> */}
        <Route path="/form_royal" element={<FormRoyal />} />
        <Route path="/form_fai" element={<FormFAI />} />
        <Route path="/form_widget_chat" element={<FormWidgetChat />} />
        <Route path="/widget" element={<WidgetPage />} />

        {/* Image Database */}
        <Route path="/image_data_base/:business_id" element={<ImageDatabase />} />
        <Route path="/image_data_base/:business_id/view" element={<ImageDatabaseView />} />

        {/* Legal Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/user-data-deletion" element={<UserDataDeletion />} />
        <Route path="/support_app" element={<SupportApp />} />
        <Route path="/copyright" element={<Copyright />} />

        <Route
          path="/unauthorized"
          element={
            <div className="p-8 text-center text-red-600 font-bold">
              Unauthorized Access
            </div>
          }
        />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <BusinessProvider>
          <Elements stripe={stripePromise}>
            <AppContent />
          </Elements>
        </BusinessProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
